export default __webpack_public_path__ + "static/media/product1.1d386e0f.png";